import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  role: "",
  role2: "",
  activated: "",
  user_name: "",
  idAuth: "",
  user_email: "",
  selectID: 3
};

export const authSlice = createSlice({
  name: "Authentication",
  initialState,
  reducers: {
    user_Authenticated: (state, action) => {
      state.isAuthenticated = true;
      state.role = action.payload.role;
      state.role2 = action.payload.role2;
      state.activated = action.payload.activated;
      state.user_name = action.payload.user_name;
      state.idAuth = action.payload.idAuth;
      state.user_email = action.payload.user_email;
    },
    user_Not_Authenticated: (state) => {
      state.isAuthenticated = false;
      state.role = initialState.role;
      state.role2 = initialState.role2;
      state.activated = initialState.activated;
      state.user_name = initialState.user_name;
      state.idAuth = initialState.idAuth;
      state.user_email = initialState.user_email;
    },
    check_Authenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    selectedIDAuth: (state, action) => {
      state.selectID = action.payload;
    },
  },
});

export const {
  user_Authenticated,
  user_Not_Authenticated,
  check_Authenticated,
  selectedIDAuth
} = authSlice.actions;

export const selectisAuthenticated = (state) => state.Authentication;

export default authSlice.reducer;
